import config from '../../../config';
import { EnrolmentFormAuthorizations as  EnrolmentFormAuthorizationsCastellarnau} from './castellarnau';
import { EnrolmentFormAuthorizations as EnrolmentFormAuthorizationsJoanOro } from './joanoro';
import { EnrolmentFormAuthorizations as EnrolmentFormAuthorizationsCavallBernat } from './cavallbernat';
import { EnrolmentFormAuthorizations as EnrolmentFormAuthorizationsPompeuFabra } from './pompeufabra';
import { EnrolmentFormAuthorizations as EnrolmentFormAuthorizationsJaumeMimo } from './jaumemimo';
import { EnrolmentFormAuthorizations as EnrolmentFormAuthorizationsArtLaIndustrial } from './artlaindustrial';
import { EnrolmentFormAuthorizations as EnrolmentFormAuthorizationsIBadia } from './ibadia';
import { EnrolmentFormAuthorizations as EnrolmentFormAuthorizationsSantaEulalia } from './santaeulalia/';
import { EnrolmentFormAuthorizations as EnrolmentFormAuthorizationsDemo } from './demo';

export default function EnrolmentFormAuthorizations(props)
{
  // console.log("CID 7",config.cid)

  switch(config.cid)
  {
     // Joan Oro
   case 'a8037152': 
   return EnrolmentFormAuthorizationsJoanOro(props)
   
   // Castellarnau
   case 'a8024893': 
   return EnrolmentFormAuthorizationsCastellarnau(props)

   // Cavall Bernat
   case 'a8053251': 
   return EnrolmentFormAuthorizationsCavallBernat(props)

     // Pompeu Fabra
   case 'a8020620': 
    return EnrolmentFormAuthorizationsPompeuFabra(props)

     // Jaume Mimó
   case 'a8044715': 
    return EnrolmentFormAuthorizationsJaumeMimo(props)

     //  Art La Industrial
   case 'a8042354': 
    return EnrolmentFormAuthorizationsArtLaIndustrial(props)

     //  IBadia
   case 'a8042342': 
   return EnrolmentFormAuthorizationsIBadia(props)
   
   //  Santa Eulàlia
   case 'a8043516':
    return EnrolmentFormAuthorizationsSantaEulalia(props)

     // DEMO
   case 'demo':
    return EnrolmentFormAuthorizationsDemo(props)

   default: //error
  }
}